import { TweenMax, TimelineMax, Power1, Power2 } from "gsap"; // Also works with TweenLite and TimelineLite
//import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { canUseDom } from "./browserCheck.js";
let ScrollMagic;
if(canUseDom()) {
    ScrollMagic = require('scrollmagic');
    require('../scripts/animation.gsap.js');
    //require('../scripts/debug.addIndicators.js');
}
export { ScrollMagic, TweenMax, TimelineMax, Power1, Power2 };